<template>
  <div>
    <!-- TOOLBAR -->
    <div class="tm-large-right"
      v-show="displayed"
      v-inject:toolbar>
      <!-- auth -->
      <tm-button
        :disabled="server.offline"
        @click="showAuth"
        :text="authenticated ? 'Authenticated' : 'Authenticate'">
      </tm-button>
      <!-- reload -->
      <tm-button
        :disabled="server.offline"
        @click="reload"
        text="Reload">
      </tm-button>
      <!-- transifex -->
      <tm-button
        class="uk-visible-large uk-button-primary"
        title="The Main Language Manager"
        href="https://www.transifex.com/projects/p/zoolanders"
        text="Transifex">
      </tm-button>
    </div>
    <!-- LANGUAGES -->
    <div v-if="!languages.length" class="uk-text-center uk-text-warning">
      Before proceeding please install the desired Joomla's language packs
      within the Joomla Language Manager.
    </div>
    <language v-for="lang in languages"
      :name="lang.name"
      :code="lang.code"
      :completed="lang.completed"
      :timestamp="lang.timestamp"
      :installed="lang.installed"
      :installed-version="lang.installedVersion"
      :server="server"
      :download="download"
      :install="install"
      :uninstall="confirmUninstall">
    </language>
  </div>
</template>

<script>
import Language from './Language'
import { languages } from '../../vuex/getters'
import { show as showAuth } from '../../vuex/actions/authentication'
import {
  retrieve,
  download,
  install,
  uninstall
} from '../../vuex/actions/languages'

export default {
  name: 'languages',
  activate: function (done) {
    this.retrieve().then(() => done())
  },
  components: { Language },
  vuex: {
    getters: {
      languages,
      server: state => state.products.server,
      view: state => state.products.view,
      authenticated: state => state.products.authentication.status
    },
    actions: {
      showAuth,
      retrieve,
      download,
      install,
      uninstall,
      promptConfirm: ({ dispatch }, text) => {
        dispatch('SHOW_MODAL_CONFIRM', { text,
          icon: ['uk-icon-exclamation', 'uk-text-warning']
        })
      },
      reload: function ({ dispatch }) {
        dispatch('SHOW_MODAL', { spinner: true, block: true })
        this.retrieve(true).then(() => dispatch('HIDE_MODAL'))
      }
    }
  },
  computed: {
    displayed: function () {
      return this.view === this.$options.name
    }
  },
  methods: {
    confirmUninstall: function (code, name) {
      this.$once('modal:confirmed', () => {
        this.uninstall(code)
      })
      this.promptConfirm(`You are about to uninstall ${name} Language Pack`)
    }
  }
}
</script>



/** WEBPACK FOOTER **
 ** Languages.vue?208277a6
 **/